import { isFuture, subMinutes } from 'date-fns';
import moment from 'moment';

export function notificationTimeFunction(
  reminderOffsetInMinutes: number,
  startDate: Date,
  startTime: string,
): string {
  if (
    (reminderOffsetInMinutes || reminderOffsetInMinutes === 0) &&
    startDate &&
    startTime
  ) {
    const hour = parseInt(startTime.slice(0, 2), 10);
    const minute = parseInt(startTime.slice(-2), 10);
    const finalVersion = moment(startDate).set({ hour, minute }).format();
    const newDate = subMinutes(new Date(finalVersion), reminderOffsetInMinutes);

    return newDate.toString();
  }

  return '';
}

export function updateAlertOptions(
  alertOptions: any[],
  startDate: Date,
  startTime: string,
): any[] {
  if (startDate && startTime) {
    const hour = parseInt(startTime.slice(0, 2), 10);
    const minute = parseInt(startTime.slice(-2), 10);

    const dateWithTime = moment(startDate)
      .set({ hour, minute, second: 0, millisecond: 0 })
      .toDate();

    return alertOptions.filter((option) =>
      isFuture(subMinutes(dateWithTime, option.value)),
    );
  }

  return [];
}
